import React from 'react';
import { Component } from 'react';
import PersonalFormsContainer from './PersonalFormsContainer';
import CarSelectionContainer from './CarSelectionContainer';
import CallHandler from '../utils/Call';
import Constants from '../data/constants';
import TimeSelectionContainer from './TimeSelectionContainer';
import ConfirmationContainer from './ConfirmationContainer';
import DriverlicenseContainer from './DriverlicenseContainer';
import formData from '../data/formSelectionData';
import LoaderSymbol from '../static/img/tesla-t-red.png';
import SuccessSymbol from '../static/img/icon-success.png';

class ContentContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loaderSuccess: '',
            loaderShow: '',
            modelAppointmentExist: false
        }

        const Tesla = window.Tesla || {};
        const country = (typeof Tesla.country !== "undefined" ? Tesla.country.toUpperCase() : "US");
        this.setIsFindus(window.location.search.includes("zip_code") && (country == "US"));
        let phoneNr = "";
        if (typeof formData.phoneNr[country] !== "undefined") {
            phoneNr = formData.phoneNr[country];
        }
        this.setData(null);
        this.setModel(null);
        if (window.location.search.includes('model=')) {
            const models = {
                "ms": Constants().MODEL_S,
                "mx": Constants().MODEL_X,
                "m3": Constants().MODEL_3,
                "my": Constants().MODEL_Y
            }

            this.setModel(models[window.location.search.split('model=')[1]]);
        }
        this.setFirstRun(true);
        this.values = {};
        this.values = {
            phone: phoneNr,
            country: country,
            locale_code: Tesla.locale,
            einterest: formData.eInterest.includes(country),
            getUpdates: formData.getUpdates.includes(country)
        };
        if (this.getIsFindus()) {
            const params = new URLSearchParams(window.location.search);
            this.values.zip = params.get("zip_code");
        }
        
        const params = new URLSearchParams(window.location.search);
        this.values.campaign = params.get("campaign");

        this.callHandler = new CallHandler();
    }

    setFirstRun(run) {
        this._firstRun = run;
    }

    getFirstRun() {
        return this._firstRun;
    }

    setModel(model) {
        this._model = model;
    }

    getModel() {
        return this._model;
    }

    setIsFindus(val) {
        this._isFindUs = val;
    }

    getIsFindus() {
        return this._isFindUs;
    }

    setData(data) {
        this._data = data;
    }

    getData() {
        return this._data;
    }

    setSortedData(data) {
        this._sortedData = data;
    }

    getSortedData() {
        return this._sortedData;
    }

    handleChange(e) {
        if (typeof e.dataPath !== "undefined") {
            this.values[e.dataPath.replace('/', '')] = e.value;
        }
        else {
            this.values[e.target.getAttribute("name")] = ( typeof e.target.checked === "undefined" ? e.target.value : e.target.checked );
        }
    }

    updateValue(key, val) {
        this.values[key] = val;
    }

    componentDidMount() {
        if (typeof window.tesla !== "undefined") {
            if (window.tesla.App.show_extra_page) {
                document.getElementsByClassName("forms-container")[0].style.position = "relative";
            }
        }
    }

    handleSubmit(e) {
        let attr = e.target.getAttribute("data-section");

        this.values.model = this.getModel();

        if (this.getModel() != null) {
            const allData = this.getData();
            for (let location in allData) {
                let currLoc = allData[location];

                if (!currLoc.storeDetails.noAppointments) {
                    if (currLoc.availableModels.indexOf(this.getModel()) > -1) {
                        break;
                    }
                }
            }

            this.setState({
                modelAppointmentExist: (allData != null)
            });
        }

        this.setState(
            {
                loaderSuccess: '',
                loaderShow: 'show'
            }
        );

        this.callHandler.post(this.values, this.getData() == null, this.getIsFindus())
            .then(
                (data) => {
                    if (data.success) {
                        if (this.getData() == null) {
                            this.setData(data.responseData);
                            if (typeof data.responseDataSorted !== "undefined") {
                                this.setSortedData(data.responseDataSorted)
                            }
                        }
                        if (typeof data.formattedDate !== "undefined") {
                            this.values.formattedDate = data.formattedDate;
                            this.values.formattedTime = data.formattedTime;
                        }
                        if (typeof data.anumber !== "undefined") {
                            this.values.anumber = data.anumber;
                        }
                        if (typeof data.snumber !== "undefined") {
                            this.values.snumber = data.snumber;
                        }
                        if (typeof data.aId !== "undefined") {
                            this.values.aId = data.aId;
                        }

                        this.setState(
                            {
                                loaderSuccess: 'success',
                            }
                        );
                    }

                    let nextStep = !this.getIsFindus();
                    let timer = 1500;
                    let top = 0;
                    if (!data.success) {
                        if (data.type === 'validation') {
                            nextStep = false;
                            let invalid = {};
                            for (let k in data.elems) {
                                invalid[k] = {
                                    class: 'tds-form-item--error',
                                    msg: data.elems[k].msg
                                }
                            }
                            this.props.store.dispatch({
                                type: Constants().VALIDATE_FORM,
                                invalid: invalid
                            });
                            timer = 500;
                            top = 200;
                        }
                    }

                    if (nextStep) {
                        this.props.store.dispatch({
                            type: Constants().NEXT_STEP,
                            currSection: attr,
                            success: data.success,
                            responseData: this.getData(),
                            model: this.getModel(),
                            values: this.values
                        });
                        if (window.location.search.includes('model=')) {
                            this.setState({
                                modelAppointmentExist: (data.responseData != null)
                            });
                        }
                    }
                    else if (this.getIsFindus()) {
                        if (this.getFirstRun()) {
                            this.props.store.dispatch({
                                type: Constants().FINDUS_NEXT_STEP,
                                initializeTimeSection: true,
                                responseData: this.getData(),
                                model: this.getModel(),
                                values: this.values
                            });

                            this.setState({
                                modelAppointmentExist: (data.responseData != null)
                            });

                            this.setFirstRun(false);
                        }

                        setTimeout(() => {
                            this.props.store.dispatch({
                                type: Constants().FINDUS_NEXT_STEP,
                                initializeTimeSection: false,
                                currSection: attr,
                                success: data.success,
                                responseData: this.getData(),
                                model: this.getModel(),
                                values: this.values
                            });
                        }, 250)
                    }

                    document.querySelector('body').scrollTo({top: top, behavior: 'smooth'});

                    setTimeout(
                        () => {
                            this.setState(
                                {
                                    loaderShow: ''
                                }
                            );
                        }, timer
                    )
                }
            )
    }

    render() {
        let { store } = this.props,
            { loaderSuccess, loaderShow } = this.state;

        const { modelAppointmentExist } = this.state;
        const image = loaderSuccess === 'success' ? SuccessSymbol : LoaderSymbol;
        let showExtraPage = false;
        if (typeof window.tesla !== "undefined") {
            showExtraPage = window.tesla.App.show_extra_page;
        }

        return (
            <div className='content-holder'>
                <PersonalFormsContainer
                    store={store}
                    handleSubmit={this.handleSubmit.bind(this)}
                    handleChange={this.handleChange.bind(this)}
                    values={this.values}
                    updateValue={this.updateValue.bind(this)} />
                <CarSelectionContainer
                    store={store}
                    handleSubmit={this.handleSubmit.bind(this)}y
                    handleSelection={this.setModel.bind(this)}
                    getData={this.getData()} />
                {modelAppointmentExist ? 
                    <TimeSelectionContainer
                        store={store}
                        handleSubmit={this.handleSubmit.bind(this)}
                        getData={this.getData.bind(this)}
                        getSortedData={this.getSortedData.bind(this)}
                        getModel={this.getModel.bind(this)}
                        handleChange={this.handleChange.bind(this)}
                        updateValue={this.updateValue.bind(this)}
                        values={this.values} />
                    : null}
                {showExtraPage ?
                    <DriverlicenseContainer
                        store={store}
                        handleSubmit={this.handleSubmit.bind(this)}y
                        handleSelection={this.setModel.bind(this)}
                        getData={this.getData()}
                        updateValue={this.updateValue.bind(this)} />
                    : null}
                <ConfirmationContainer
                    store={store}
                    handleSubmit={this.handleSubmit.bind(this)}
                    handleChange={this.handleChange.bind(this)}
                    getData={this.getData.bind(this)} />
                <div className={'loader ' + loaderSuccess + ' ' + loaderShow}>
                    <span style={{backgroundImage: `url(${Constants().RESOURCE_BASE_URL}${image})`}}>
                    </span>
                </div>
            </div>
        );
    }
}

export default ContentContainer;
